export default "__VITE_ASSET__J94XbSiI__"